import level1_1 from "./assets/01/A1_b.png";
import level1_2 from "./assets/01/A2_b.png";
import level1_3 from "./assets/01/A3_b.png";

import level2_A1_1 from "./assets/02/A1_1.png";
import level2_A1_2 from "./assets/02/A1_2.png";
import level2_A1_3 from "./assets/02/A1_3.png";
import level2_A1_4 from "./assets/02/A1_4.png";
import level2_A1_5 from "./assets/02/A1_5.png";

import level2_A2_1 from "./assets/02/A2_1.png";
import level2_A2_2 from "./assets/02/A2_2.png";
import level2_A2_3 from "./assets/02/A2_3.png";
import level2_A2_4 from "./assets/02/A2_4.png";
import level2_A2_5 from "./assets/02/A2_5.png";

import level2_A3_1 from "./assets/02/A3_1.png";
import level2_A3_2 from "./assets/02/A3_2.png";
import level2_A3_3 from "./assets/02/A3_3.png";
import level2_A3_4 from "./assets/02/A3_4.png";
import level2_A3_5 from "./assets/02/A3_5.png";

import level3_1 from "./assets/03/C01.png";
import level3_2 from "./assets/03/C02.png";
import level3_3 from "./assets/03/C03.png";
import level3_4 from "./assets/03/C04.png";
import level3_5 from "./assets/03/C05.png";
import level4_1 from "./assets/04/B01.png";
import level4_2 from "./assets/04/B02.png";
import level4_3 from "./assets/04/B03.png";
import level4_4 from "./assets/04/B04.png";
import level4_5 from "./assets/04/B05.png";
import level5_1 from "./assets/05/D01.png";
import level5_2 from "./assets/05/D02.png";
import level5_3 from "./assets/05/D03.png";
import level5_4 from "./assets/05/D04.png";
import level5_5 from "./assets/05/D05.png";
import level6_1 from "./assets/06/E01.png";
import level6_2 from "./assets/06/E02.png";
import level6_3 from "./assets/06/E03.png";
import level6_4 from "./assets/06/E04.png";
import level6_5 from "./assets/06/E05.png";

import level1_1_icon from "./assets/01/A1_s.png";
import level1_2_icon from "./assets/01/A2_s.png";
import level1_3_icon from "./assets/01/A3_s.png";

import level2_1_icon from "./assets/02/1_s.png";
import level2_2_icon from "./assets/02/2_s.png";
import level2_3_icon from "./assets/02/3_s.png";
import level2_4_icon from "./assets/02/4_s.png";
import level2_5_icon from "./assets/02/5_s.png";

import level3_1_icon from "./assets/03/C01_s.png";
import level3_2_icon from "./assets/03/C02_s.png";
import level3_3_icon from "./assets/03/C03_s.png";
import level3_4_icon from "./assets/03/C04_s.png";
import level3_5_icon from "./assets/03/C05_s.png";
import level4_1_icon from "./assets/04/B01_s.png";
import level4_2_icon from "./assets/04/B02_s.png";
import level4_3_icon from "./assets/04/B03_s.png";
import level4_4_icon from "./assets/04/B04_s.png";
import level4_5_icon from "./assets/04/B05_s.png";
import level5_1_icon from "./assets/05/D01_s.png";
import level5_2_icon from "./assets/05/D02_s.png";
import level5_3_icon from "./assets/05/D03_s.png";
import level5_4_icon from "./assets/05/D04_s.png";
import level5_5_icon from "./assets/05/D05_s.png";
import level6_1_icon from "./assets/06/E01_s.png";
import level6_2_icon from "./assets/06/E02_s.png";
import level6_3_icon from "./assets/06/E03_s.png";
import level6_4_icon from "./assets/06/E04_s.png";
import level6_5_icon from "./assets/06/E05_s.png";

import level7_1_icon from "./assets/F01a.png";

const ImageMap: { [index: string]: string } = {
  level1_1: level1_1,
  level1_2: level1_2,
  level1_3: level1_3,
  level1_1_level2_1: level2_A1_1,
  level1_1_level2_2: level2_A1_2,
  level1_1_level2_3: level2_A1_3,
  level1_1_level2_4: level2_A1_4,
  level1_1_level2_5: level2_A1_5,
  level1_2_level2_1: level2_A2_1,
  level1_2_level2_2: level2_A2_2,
  level1_2_level2_3: level2_A2_3,
  level1_2_level2_4: level2_A2_4,
  level1_2_level2_5: level2_A2_5,
  level1_3_level2_1: level2_A3_1,
  level1_3_level2_2: level2_A3_2,
  level1_3_level2_3: level2_A3_3,
  level1_3_level2_4: level2_A3_4,
  level1_3_level2_5: level2_A3_5,
  level3_1: level3_1,
  level3_2: level3_2,
  level3_3: level3_3,
  level3_4: level3_4,
  level3_5: level3_5,
  level4_1: level4_1,
  level4_2: level4_2,
  level4_3: level4_3,
  level4_4: level4_4,
  level4_5: level4_5,
  level5_1: level5_1,
  level5_2: level5_2,
  level5_3: level5_3,
  level5_4: level5_4,
  level5_5: level5_5,
  level6_1: level6_1,
  level6_2: level6_2,
  level6_3: level6_3,
  level6_4: level6_4,
  level6_5: level6_5,
};

const IconMap: { [index: string]: string } = {
  level1_1: level1_1_icon,
  level1_2: level1_2_icon,
  level1_3: level1_3_icon,
  level2_1: level2_1_icon,
  level2_2: level2_2_icon,
  level2_3: level2_3_icon,
  level2_4: level2_4_icon,
  level2_5: level2_5_icon,
  level3_1: level3_1_icon,
  level3_2: level3_2_icon,
  level3_3: level3_3_icon,
  level3_4: level3_4_icon,
  level3_5: level3_5_icon,
  level4_1: level4_1_icon,
  level4_2: level4_2_icon,
  level4_3: level4_3_icon,
  level4_4: level4_4_icon,
  level4_5: level4_5_icon,
  level5_1: level5_1_icon,
  level5_2: level5_2_icon,
  level5_3: level5_3_icon,
  level5_4: level5_4_icon,
  level5_5: level5_5_icon,
  level6_1: level6_1_icon,
  level6_2: level6_2_icon,
  level6_3: level6_3_icon,
  level6_4: level6_4_icon,
  level6_5: level6_5_icon,
  level7_1: level7_1_icon,
};

export { IconMap, ImageMap };

export default ImageMap;
